import React, { useEffect } from "react";
import st from "../../style.module.scss";
import { useFieldArray } from "react-hook-form";
import { Col, Form, Row } from "react-bootstrap";
import { FaRegCircle } from "react-icons/fa";
import AddSubRisk from "./AddSubRisk";
import { MdDelete } from "react-icons/md";
import AddScorePointsRange from "./AddScorePointsRange";

export default ({
  nestIndex,
  control,
  register,
  errors,
  getValues,
  setError,
  watch,
  clearErrors,
  setValue,
}) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: `noOfYears.${nestIndex}.children`,
  });

  return (
    <div>
      {fields.map((item, k) => {
        if (
          !getValues(`noOfYears.${nestIndex}.children.${k}.stockDistribution`)
            ?.length
        ) {
          setValue(`noOfYears.${nestIndex}.children.${k}`, {
            label: "",
            min: "",
            max: "",
            stockDistribution: [
              {
                key: "",
                value: "",
              },
            ],
          });
        }
        return (
          <div
            className="col-12 my-3 py-3 ps-3"
            key={item.id}
            style={{ marginLeft: 20, border: "1px solid blue" }}
          >

            <AddScorePointsRange
              nestIndex={nestIndex}
              k={k}
              {...{
                register,
                watch,
                setError,
                clearErrors,
                errors,
                remove
              }}

            />

            <Row className="px-0 mx-0">
              <Col lg={12}>
                <AddSubRisk
                  nestIndex={nestIndex}
                  k={k}
                  {...{
                    control,
                    register,
                    errors,
                    setError,
                    clearErrors,
                    getValues,
                  }}
                />
              </Col>

              <div>
                <Form.Label
                  htmlFor={`noOfYears.${nestIndex}.children.${k}.topComment`}
                >
                  Top comment
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Top comment"
                  {...register(
                    `noOfYears.${nestIndex}.children.${k}.topComment`,
                    {
                      required: "comment is required",
                    }
                  )}
                  isInvalid={
                    !!errors.noOfYears?.[nestIndex]?.children?.[k]?.topComment
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {
                    errors.noOfYears?.[nestIndex]?.children?.[k]?.topComment
                      ?.message
                  }
                </Form.Control.Feedback>
                {/* {errors.noOfYears?.[nestIndex]?.children?.[k]?.topComment?.message && <span className="text-danger">This field is required</span>} */}
              </div>

              <div>
                <Form.Label
                  htmlFor={`noOfYears.${nestIndex}.children.${k}.middleComment`}
                >
                  Middle comment
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Middle comment"
                  {...register(
                    `noOfYears.${nestIndex}.children.${k}.middleComment`,
                    {
                      required: "comment is required",
                    }
                  )}
                  isInvalid={
                    !!errors.noOfYears?.[nestIndex]?.children?.[k]
                      ?.middleComment
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {
                    errors.noOfYears?.[nestIndex]?.children?.[k]?.middleComment
                      ?.message
                  }
                </Form.Control.Feedback>
                {/* {errors.noOfYears?.[nestIndex]?.children?.[k]?.middleComment?.message && <span className="text-danger">This field is required</span>} */}
              </div>

              <div>
                <Form.Label
                  htmlFor={`noOfYears.${nestIndex}.children.${k}.bottomComment`}
                >
                  Bottom comment
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Bottom comment"
                  {...register(
                    `noOfYears.${nestIndex}.children.${k}.bottomComment`,
                    {
                      required: "comment is required",
                    }
                  )}
                  isInvalid={
                    !!errors.noOfYears?.[nestIndex]?.children?.[k]
                      ?.bottomComment
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {
                    errors.noOfYears?.[nestIndex]?.children?.[k]?.bottomComment
                      ?.message
                  }
                </Form.Control.Feedback>
                {/* {errors.noOfYears?.[nestIndex]?.children?.[k]?.bottomComment?.message && <span className="text-danger">This field is required</span>} */}
              </div>
            </Row>
          </div>
        );
      })}

      <div>
        <Form.Group className={`${st.formField} ${st.new_formFields} d-flex`}>
          <div className={`${st.tableAction} mb-0`}>
            <button
              style={{ color: "#fff", background: "#7f8699" }}
              type="button"
              className={`btn`}
              onClick={() =>
                append({
                  label: "",
                  min: "",
                  max: "",
                  stockDistribution: [],
                })
              }
            >
              Add score label
            </button>
          </div>
        </Form.Group>
      </div>
    </div>
  );
};
